export default function Spinner(props){
    return (
        <div class={`spinner-border text-secondary  ${props.className ? props.className: 'spinner-border-sm'}`} role="status">
        <span class="sr-only text-muted">Loading...</span>
      </div>
    )
}